import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private http:HttpClient) { }

  GetRecord(Token:String,id:number):Observable<Array<Behfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Help?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Behfa_Interface>
      })
    )
  }

  GetRecordUrl(Token:String,url:String):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Help/GetRecordUrl?token="+Token+"&url="+url).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetSingle(Token:String,id:number):Observable<Behfa_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Help/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  AddEditHelp(model: Behfa_Interface,id:number,Token:String):Observable<Behfa_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      menu_id:id,
      val:model.val+'',
      type:model.type,
      create_user:Token
    }

    return this.http.post(environment.BaseUrl + "Daro/Help/AddEdit",body,{headers}).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  DeleteHelp(id:number,Token:String):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Help/Delete?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  PriorityHelp(id:number,Token:String):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Help/Priority?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Help/Upload?token="+Token,body).pipe(
      map(data=>{

        return data
      })
    )
  }

}
